export class TranslateMalay {
  public static headerMenu = {
    home: "Laman Utama",
    login: "Log Masuk",
    aboutUpskill: "Tentang Kami",
    courses: "Kursus",
    whatweoffer: "Tawaran Kami",
    empbenefits: "Faedah Majikan",
    indbenefits: "Faedah Individu",
    partnership: "Jalinan Kerjasama",
    hiring: "Penempatan Pekerjaan",
    trainingfremp: "Latihan Untuk Pekerja Anda",
    funding: "Pembiayaan",
    othogminit: "Program/Insiatif Lain",
    hrconsult: "Rundingan Sumber Manusia",
    elatih: "Elatih",
    loginSubMenu: {
      individual: "Log Masuk Individu",
      employerLogin: "Log Masuk Majikan",
      agencyLogin: "Log Masuk Pentadbir",
    },
    insights: "Sumber",
    insightsSubMenu: {
      reportArticles: "Laporan & Artikel",
      skillFramework: "Kerangka Kemahiran Industri",
      upskillinsights: "Pandangan Upskilling",
      upskillstatistics: "Statistik Dan Pandangan Upskillmalaysia",
    },
    mediaGallery: "Galeri Media",
    contactUs: "Hubungi Kami",
    individual: "Log Masuk Individu",
    agencyLogin: "Log Masuk Pentadbir",
    trainingProviderLogin:"Log Masuk Penyedia Kursus",
    faq: "Soalan Lazim",
    guidelines: "Manual Pengguna",
    individuals: "Individu",
    tp: "Penyedia Kursus",
    agency: "Agensi",
    manual1: "Laporan Pasca Latihan & e-sijil",
    active_courses: "Kursus Aktif",
    archived_courses: "Kursus Arkib",
    navigation: "Navigasi",
    overview: "Tentang NTW",
    objectives: "Objektif",
    pillars: "Teras & Bidang Utama",
    elearning: "E-Pembelajaran",
    benefits: "Manfaat",
    target: "Kumpulan Sasaran",
    gallery: "Galeri",
    satelliteevents: "Acara Satelit",
    cimanual: "Garis Panduan Jenama"
  };

  //Jobseeker Menu
  public static jobSeekerMenu = {
    home: "LAMAN UTAMA",
    courses: "KURSUS",
    archive_courses: "KURSUS ARKIB",
    jobSearch: "CARIAN PEKERJAAN",
    jobs: "PEKERJAAN",
    appliedJobs: "PERMOHONAN PEKERJAAN",
    interviewScheduledJobs: "TEMU RAMAH PEKERJAAN BERJADUAL",
    savedJobs: "PEKERJAAN YANG DISIMPAN",
    jobFilters: "PENAPIS KERJA",
    appliedCourses: "KURSUS DISERTAI",
    satelliteEvents: "ACARA SATELIT",
    myProfiles: "PROFIL PERIBADI",
    employerChat: "SEMBANG MAJIKAN",
    geofencingJobs: "GEOGENCING JOBS",
    myCertificate: "Senarai Sijil",
  };

  public static footerData = {
    menu: "Menu",
    mainPage: "Laman Utama",
    individualLogin: "Log Masuk Individu",
    employersLogin: "Log Masuk Majikan",
    agencyLogin: "Log Masuk Agensi",
    mohrandmofLogin: "Log Masuk MOHR & MOF",
    adminLogin: "Log Masuk",
    legislation: "PERUNDANGAN",
    privacyPolicy: "Privasi & Polisi",
    pdpa: "PDPA",
    contactUS: "HUBUNGI KAMI",
    pleaseContactUS:
      "Sila hubungi kami melalui e-mel berikut untuk maklumat lanjut:",
    taskforceEmail: "taskforce@nationaltraningweek.gov.my",
    rights: "©️ 2023 National Training WEek. Hak Cipta Terpelihara",
    navigation: "Navigasi",
    home: "Laman Utama",
    aboutUs: "Tentang Kami",
    courses: "Kursus",
    contact: "Hubungi Kami",
    quickLinks: "Pautan Pantas",
    disc: "Perbincangan",
    terms: "Terma & Syarat",
    support: "Sokongan pengguna",
    faq: "Soalan Lazim",
  };

  /**
   * Job Seeker Signup for data
   */
  public static jobseekerSignupFormData = {
    myBasicInfo: "Maklumat Asas Peribadi",
    signupFree: "Daftar secara PERCUMA untuk mendapatkan padanan pekerjaan",
    name: "Nama",
    phoneNumber: "Nombor telefon",
    phoneNumberPH: "masukkan nombor telefon",
    emailAddress: "Alamat email",
    sampleEmail: "contoh@email.com",
    icNumber: "Nombor kad pengenalan",
    icNumberPH: "Masukkan nombor kad pengenalan",
    createPassword: "Reka kata laluan",
    createPasswordPH: "Masukkan kata laluan",
    confirmPassword: "Sahkan kata laluan",
    confirmPasswordPH: "Masukkan kata laluan",
    nationality : "Kewarganegaraan",
    state : "Negeri",
    other_country : "Negara Lain",
    otherCountryPH : "Nama Negara",
    passport : "Nombor Pasport",
    passportPH:"Sila masukkan nombor pasport",
    dob : "Tarikh Lahir",
    gender : 'Jantina',
    event : "Maklumat Khusus Acara", 
    employment : 'Pengesahan Pekerjaan',
    organisation : 'Pengesahan Organisasi',
    declaration : 'I agree with ...',
    alternativeEmail : 'E-mel Alternatif',
    alternativePhoneNumber : 'Nombor Telefon Alternatif',
    personalInfo : 'Maklumat Peribadi',
    alternativeContact:"Perhubungan Alternatif",
    eventAndOrganization : 'Acara & Organisasi',
    others : 'Lain-lain',
    fresher: "Saya tidak mempunyai pengalaman Bekerja",
    pswInstruction:
      "Guna 8 atau lebih karektor abjad  dengan gabungan huruf besar, huruf kecil, angka & simbol",
    keySkills: "Kemahiran utama",
    keySkillsPH: "Pilih kemahiran utama",
    add: "Tambah",
    conditionalQuestion: "Tambah soalan bersyarat (untuk padanan kursus)",
    targetGroupTitle: "What is your target group?",
    whichCategoryTitle: "Kategori mana yang anda ingin sertai?",
    chooseOption: "Buat pilihan",
    statethelocation:
      "Nyatakan pilihan lokasi penempatan Pekerjaan atau latihan yang diinginkan",
    currentlyUnemployed: "Saya sekarang tidak bekerja",
    agreeCondition:
      "Saya bersetuju untuk mematuhi terma dan syarat-syarat oleh  HRD Corp",
    getStarted: "Teruskan",
    agree: "Saya bersetuju dengan",
    terms: "Terma dan syarat",
    hrdf: "HRD Corp.",
    candidatenamereq: "Medan 'Nama Calon' ini perlu diisi",
    phonenumreq: "Medan 'Nombor Telefon' ini perlu diisi",
    phonecharreq:
      "Medan 'Nombor Telefon' mestilah sekurang-kurangnya 10 aksara",
    emailreq: "Medan 'ID E-mel' ini perlu diisi",
    emailexists: "ID E-mel telah didaftarkan!",
    icnumreq:
      "Medan 'Nombor Kad Pengenalan' mestilah sekurang-kurangnya 12 aksara",
    icnumexists: "Nombor IC Telah Didaftarkan!",
    icnumcharreq:
      "Medan 'Nombor Kad Pengenalan' mestilah sekurang-kurangnya 12 aksara",
    passwordreq: "Medan 'Kata Laluan' ini perlu diisi",
    passcharreq: "Medan 'Kata Laluan' mestilah sekurang-kurangnya 8 aksara",
    passcharnumreq:
      "Kata laluan mesti mengandungi sekurang-kurangnya satu huruf besar, satu huruf kecil, satu nombor, dan satu simbol khas",
    confirmpassreq: "Medan 'Pengesahan Kata Laluan' ini perlu diisi",
    passmatchreq: "Kata Laluan Tidak Sesuai",
    keyskillreq: "Medan 'kata Kunci Kemahiran' ini perlu diisi",
    coditionalreq: "Sila pilih soalan",
    termscheckreq: "Bersetuju dengan Terma dan Syarat",
    conditionalquestion: "Soalan Bersyarat (Untuk Padanan Kursus)",
    procedifdatacorrect:
      "Sila ke bahagian seterusnya sekiranya maklumat yang diisi tepat",
    resumeChooseLabel: "Pilih",
    uploadResume: "Muat Naik Resume",
    format: "Format yang disokong: pdf sahaja, sehingga 2 MB",
    previous: "Sebelumnya",
    next: "Teruskan",
    createAccount: "Daftar Akaun",
    currentstatus: "Status Semasa",
    selectlocationplaceholder: "Pilih Lokasi",
    selectCurrentStatus: "Pilih Status Semasa",
    registrationsuccess:
      "Pendaftaran anda telah berjaya, sila semak email anda untuk maklumat log masuk",
    success: "Berjaya",
    nameplaceholder: "Masukkan nama mengikut kad pengenalan",
    register: "Pendaftaran",
    tag: "Mulakan perjalanan anda untuk pembangunan kemahiran sepanjang hayat",
    agreeToReceive: "Saya bersetuju untuk menerima e-mel pemasaran dan promosi",
    mandatoryInfo: "Maklumat wajib",
  };

  /**
   * Home page content
   */
  public static homePageData = {
    title: "UPSKILLMALAYSIA",
    subTitle: "Meningkatkan Kemahiran untuk Memenuhi Permintaan Industri",
    description: "Buka potensi anda dengan peluang pembelajaran tanpa had",
    subdescription: "Daftar sekarang dan temui kuasa pengetahuan",
    courses: "Kursus",
    jobs: "Jawatan Kosong",
    searchBoxPH: "Carian",
    myFutureJobs: "MY FUTURE JOBS",
    myFutureJobsContent:
      "Penempatan pekerjaan dan insentif pengambilan pekerja di bawah perlaksanaan PERKESO melalui Penjana Kerjaya,  khusus untuk graduan dan individu yang hilang pekerjaan.",
    clickHere: "Klik di sini",
    departmentOfLabour: "Jabatan Tenaga Kerja",
    departmentOfLabourContent:
      "Penyelesaian & Solusi Berkaitan Urusan Pengambilan Pekerja",
    nhrc: "Pusat Sumber Manusia Kebangsaan [NHRC]",
    nhrcContent:
      "Penasihat Dan Konsultasi Mengenai Perundingan  Sumber Manusia",
    akpk: "AGENSI KAUNSELING & PENGURUSAN KREDIT (AKPK)",
    akpkContent:
      "Perkhidmatan Kaunselling dan Pendidikkan Pengurusan Kredit Membantu Individu Menguasai Situasi Kewangan Bijak Dan Berhemat",
    mainObjective: "OBJEKTIF UTAMA",
    centralisedInformation: "Konsolidasi Informasi & Data Maklumat Berpusat",
    centralisedInformationContent:
      "Perincian Informasi Lengkap & Koprehensif Mengenai Peluang Tersedia Untuk Memenuhi Keperluan Individu",
    jobOppertunity: "Peluang Pekerjaan",
    jobOppertunityContent:
      "Kerjaya dipadankan mengikut kualifikasi dan kecenderungan individu",
    trainingMatching: "Padanan Kursus Latihan",
    trainingMatchingContent:
      "Padanan kursus yang sesuai berdasarkan maklumat pemohon",
    careerInsights: "Wawasan Kerjaya",
    careerInsightsContent:
      "Rancang kerjaya anda berdasarkan statistik yang tersedia dan permintaan tinggi dalam industri",
    ministriesandAgencies: "KEMENTERIAN & AGENSI",
    whoShouldParticipate: "PIHAK YANG PERLU MENGAMBIL BAHAGIAN",
    individuals: "INDIVIDU",
    individualsContent:
      "Daftar  Dalam Program Latihan Yang Disediakan Bagi Meningkatkan Kebolehpasaran Untuk Menjana Pendapatan",
    applyNow: "Daftar sekarang",
    employers: "MAJIKAN",
    employersContent:
      "Menyediakan program latihan kepada pekerja atau calon pekerja untuk meningkatkan ilmu  dan potensi dalam mengembang dan mengukuhkan perniagaan",
    ministriesAndAgencies: "KEMENTERIAN & AGENSI",
    ministriesandAgenciesContent:
      "Menyenaraikan Program Latihan berkemahiran tinggi yang boleh meningkatkan skil , kualiti perkhidmatan atau produk bagi mengembangkan   potensi kebolehpasaran",
    testimonals: "TESTIMONI",
    anIntegratedTitle: "Portal Bersepadu Yang Memenuhi Keperluan Unik Anda",
    anIntegratedContent:
      "Portal bersepadu untuk rakyat Malaysia yang menyediakan akses ke program latihan, peluang pekerjaan, kemahiran keusahawanan, nasihat, sokongan perancangan kerjaya, maklumat mengenai undang-undang pekerjaan dan maklumat lain yang berkaitan",
    matching: "Padanan",
    aiTitle: "Kecerdasan Buatan",
    aiContent:
      "Kemahiran Dan Minat Individu Dipadankan Dengan Tepat Untuk Program Atau Keperluan Pekerjaan Dengan Tindak Balas Segera",
    employerAd: "PERHATIAN KEPADA SEMUA MAJIKAN",
    employerAdSub: "UNTUK MENGIKLANKAN KEKOSONGAN PEKERJAAN",
    employerAdSub2:
      "MANFAATKAN INSENTIF LATIHAN DAN KELOMPOK BAKAT YANG TERSEDIA",
    individualAd: "PERHATIAN KEPADA SEMUA INDIVIDU",
    individualAdSub: "UNTUK MENDAFTARKAN PROFIL MEREKA",
    individualAdSub2: "MEMOHON PEKERJAAN DAN PELUANG PEMBANGUNAN KERJAYA",
    benefits: "Faedah Majikan",
    individualBenefits: "Faedah Individu",
    elatih: "E-Latih",
    insights: "Pandangan",
    partnerships: "Jalinan Kerjasama",
    jobplacement:"Penempatan Pekerjaan",
    entregig:"Keusahawanan / GIG",
    skillimpro:"Peningkatan Kemahiran / Pengekalan Pekerjaan",
    jobplacementdesc:"Dapatkan peluang pekerjaan dengan menyertai program latihan kemahiran berasaskan keperluan industri ",
    entregigdesc:"Program latihan bagi meningkatkan kebolehpasaran pekerjaan bagi menjana pendapatan atau bekerja sambilan",
    skillimprodesc:" Meningkatkan kemahiran dan pengetahuan khusus untuk peluang penjana pendapatan dalam pelbagai bidang",
    centralizedInfo: "Pusat maklumat sehenti bagi program peningkatan kemahiran dan latihan semula yang ditawarkan oleh Kementerian dan Agensi.",
    jobMatching: "Instrumen laman sesawang yang menilai kelayakan akademik individu untuk padanan penempatan pekerjaan yang bersesuaian.",
    courseMatching: "Terokai pelbagai pilihan dan padanan kursus berdasarkan profil individu dan minat anda.",
    tagline:"Sekiranya anda mencari pekerjaan dan peluang untuk memasuki pasaran pekerjaan, maka kami sedia membantu anda! Lihat semua peluang terkini, bimbingan kerjaya dan banyak lagi.",
    availCourses: "Kursus Tersedia",
    trainingStats: "Penyedia Kursus",
    applications: "Permohonan",
    agency: "Agensi",
    searchKey: "Sila masukkan kata kunci",
    areYouEmployer: "Anda Majikan?",
    clickHereTo: "Klik di sini untuk daftar",
    yourAccount: "akaun anda",
    individual: "Anda Individu?",
    indiviAccount: "profil anda",
    certInfo: "Maklumat Sehenti",
    jobMatchingPlacement: "Padanan & Penempatan Pekerjaan",
    courseMatchingTitle: "Padanan Kursus",
    explore: "Carian Kursus Popular",
    viewall: "Lihat Semua",
    catagories: "Kategori",
    catagoryDesc: "Komponen tenaga kerja merupakan sumber terpenting di UpskillMalaysia. Kami menawarkan peluang melalui tiga kategori serta pelbagai inisiatif lain.",
    partnership1: "Dengan",
    partnership2: " kerjasama",
    tab1: "Keusahawanan / GIG",
    tab2: "Penempatan Pekerjaan",
    tab3: "Peningkatan Kemahiran",
    tagLine1: "",
    tagLine2: " ",
    tagLine3: " ",
    tagLine4: " ",
    skills: "Bidang Kemahiran​",
    skillsTitle: "Pilih kursus dari Bidang Kemahiran berikut",
    centralInfo: "Pusat Maklumat",
    centralInfoSub: "Dapatkan maklumat terkini mengenai semua program peningkatan latihan dan latihan semula yang ditawarkan oleh kementerian serta agensi kerajaan di dalam satu platform bersepadu.",
    skillsRepo: "Pendokumentasian Kemahiran",
    skillsRepoSub: "Rekod semua kemahiran, pengalaman, kelayakan dan latihan profesional anda di satu tempat, secara komprehensif.",
    courseMatch: "Padanan Kursus",
    courseMatchSub: "Terokai pilihan anda sambil mencari padanan kursus terbaik berdasarkan profil anda",
    feedBack: "Apa kata pengguna",
    all: "Semua",
    noCourse: "Tiada Kursus Ditemui",
    slots: "Slot",
    click: "Klik pada peta untuk melihat",
    click_photos: "Klik pada foto untuk melihat laman sosial kami",
    available_seats: "Tempat Tersedia",
    unlimited_seats: "Tersedia Tanpa Had",
    foc: "PERCUMA",
    enrolments: "Penyertaan",
    registerNow: "Daftar sekarang",
    noEvent: "Tiada Acara Ditemui",
    noPartners: "Tiada Rakan Strategik Ditemui",
  };

  public static aboutUsPageData = {
    description: "Tentang Kami",
    subdescription: "Memacu latihan kemahiran dan pembangunan Malaysia untuk masa depan yang lebih cerah",
  }

  public static agencyMedacData = {
    medacTitle: "Kementerian Pembangunan Usahawan & Koperasi (MEDAC)",
    mainDescription:
      "Menawarkan inisiatif pembangunan melalui Latihan dan kemahiran perniagaan untuk membantu mereka yang berminat menjadi usahawan.",
    title1: "INSKEN – Kursus Latihan Perniagaan",
    description: "Penerangan:",
    content1:
      "Latihan jangka pendek yang memberi tumpuan kepada teknik ‘ilmu pengetahuan’ yang membimbing usahawan dalam menubuh dan memperkukuhkan operasi mereka dari sehari ke sehari. Ini khususnya untuk meningkatkan kemampuan usahawan dalam memikul tanggungjawab sebagai pengurus kanan sesebuah syarikat dan pengurusan PKS.",
    title2: "Program Bimbingan boarding dalam talian (e-Board)",
    content2:
      "Program ini bertujuan untuk memperkukuhkan kemampuan pengusaha mikro kecil dan sederhana tempatan dalam menggunakan platform dalam talian secara pemerhatian khusus dan bimbingan intensif selama 3 bulan.",
    title3: "Program Pembangunan Industri Kejurulatihan Pertanian (ACID)",
    content3:
      "Meningkatkan kemahiran keushawanan antara belia dan masyarakat luar bandar yang tergolong dalam kumpulan B40 melalui latihan dan bimbingan perniagaan dengan melaksaanakan program yang berfokus pada pertanian.",
    title4: "Program Keusahawanan Koperasi",
    content4:
      "Inisiatif yang membantu koperasi di sector yang terlibat dengan menuju ke arah perniagaan baru melalui latihan dan kemahiran baru",
    title5: "Program Tunas Usahawan Belia Bumiputera (TUBE)",
    content5:
      "Pogram ini mensasarkan golongan muda Bumiputera berumur antara 18-30 tahun yang berminat untuk menceburkan diri dalam bidang keusahawanan terutamanya mereka yang sudah mempunyai sijil asas bidang berkaitan",
    title6: "Program Usahawan Muda",
    content6:
      "Program ini bertujuan untuk mengasah keupayaan peserta dari peringkat meneroka idea perniagaan yang baik untuk menguji potensi system perniagaan yang berdaya maju serta sistematik. Program ini juga membantu usahawan muda untuk merumuskan strategi pemasaran melalui pemasaran digital.",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyKptData = {
    kptTitle: "Kementerian Pengajian Tinggi",
    kptDescription:
      "Menawarkan program yang memberi impak dan nilai tambah kepada kemahiran graduan yang baru sahaja lulus pada tahun 2019 hingga 2020",
    description: "Penerangan:",
    title1: "Padanan & Penempatan Kerja",
    content1:
      "Program peningkatan kemahiran yang kompetitif yang disasarkan akan diberikan untuk memadankan peserta berdasarkan keperluan industry bagi memastikan pekerjaan yang ditawarkan dapat dilaksanakan dengan baik.",
    title2: "Program Keusahawanan",
    content2:
      "Latihan kompeten yang dapat meningkatkan kemahiran dan pengetahuan peserta dalam bidang keushawanan dan dapat menubuhkan syarikat permulaan dengan bantuan pembiayaan yang disediakan oleh agensi pembiayaan yang diiktiraf.",
    title3: "Program Gig Economy",
    content3:
      "Program Latihan kompeten yang dapat membantu peserta menjana pendapatan melalui Gig Economy atau aktiviti kerja bebas",
    title4: "Program Reskilling & Upskilling",
    content4:
      "Program kemahiran dan peningkatan kemahiran yang disasarkan akan diberikan kepada peserta berdasarkan keperluan industri untuk memastikan bahawa peserta ditawarkan pekerjaan dengan gaji permulaan yang tinggi atau menceburkan diri dalam bidang keusahawanan yang berkaitan dengan latihan yang diambil",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyMotacData = {
    motacTitle: "Kementerian Pelancongan, Seni dan Budaya (MOTAC)",
    motacDescription:
      "Menawarkan program yang menumpukan pada pengembangan kemahiran seni dan keusahawanan yang akan memberi manfaat kepada industry seni dan kreatif.",
    description: "Penerangan:",
    title1: "Pembangunan Kemahiran Komuniti",
    content1: "Program ini terbuka kepada semua :",
    list1: "1.Belia",
    list2: "2.Kumpulan kategori B40 dalam dan luar bandar",
    list3: "3.Ibu tunggal",
    list4: "4.Golongan kurang upaya (OKU)",
    list5: "5.Warga emas, komuniti etnik pribumi Sabah & Sarawak",
    list6: "6.Native indigenous ethnic community of Sabah & Sarawak",
    list7:
      "7.Majikan atau individu yang terjejas oleh pandemik Covid19 yang berhasrat menjadikan produk warisan sebagai sumber penjanaan pendapatan",
    title2: "Pembangunan Kemahiran Perantisan",
    content2:
      "Menyediakan kemudahan baru untuk latihan tenaga kerja yang terdiri dari kalangan belia, penganggur dan individu dengan menawarkan peluang pekerjaan dengan pengusaha kraf terpilih. Program ini membantu pengusahakraf mendapatkan tenaga kerja yang mahir dan memastikan bahawa perusahaan dapat beroperasi secara berterusan dan lebih kompetitif.",
    title3: "Pembangunan Keusahawanan Seni Siri",
    content3:
      "Pembangunan keusahawanan seni, SIRI, adalah kursus keusahawanan seni dengan menawarkan pemahaman yang luast tentang perniagaan dalam seni persembahan",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyKbsData = {
    kbsTitle: "Kementerian Belia dan Sukan [KBS]",
    kbsDescription:
      "Memupuk nilai keusahawanan di kalangan pelajar ILKBSTVET dan pengiktirafan pencapaian terdahulu berdasarkan pengalaman dan pencapaian",
    description: "Penerangan:",
    title1: "Makerspace Mybizhub",
    content1:
      "Memberi ruang serta Latihan teknikal yang melibatkan bidang keusahawanan [TVETPRENEUR] di kalangan belia dan graduan ILKBS",
    title2: "Program Inkubator",
    content2:
      "Memberi ruang dan Latihan teknikal yang melibatkan bidang keusahawan [TVETPRENEUR] dikalangan pelajar TVET ILKBS",
    title3: "Kursus Modular",
    content3:
      "Program Latihan kemahiran jangka pendek selama 3 hingga 6 bulan berdasarkan proses kerja sebenar",
    title4: "Pengiktirafan Pecapaian Terdahulu [PPT]",
    content4:
      "Menyediakan dan memberi pengiktirafan kepada pekerja mahir negara yang dapat membuktikan kemahiran yang digariskandalam Standard Kemahiran Pekerjaan Negara [SKPK] berdasarkan pengalaman dan pencapaian sebelumnya",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyHrdfData = {
    hrdfTitle: "Dana PembangunanSumber Corp (HRDCorp)",
    hrdfDescription:
      "HRD Corp telah memperkenalkan 5 skim yang memfokuskan kepada hasil kebolehpasaran untuk pekerja yang ada dan yang akan dating serta rakyat Malaysia yang menyokong pertumbuhan ekonomi.",
    description: "Penerangan:",
    title1: "Penempatan & Latihan",
    content1:
      "Inisiatif untuk menyediakan pekerjaan kepada belia, graduan yang menganggur, individu yang diberhentikan kerja. Melalui penyertaan dalam kursus latihan ini, ia akan memberikan nilai tambah dengan memenuhi keperluan industri serta memastikan penempatan pekerjaan.",
    title2: "Pembangunan B40",
    content2:
      "Initiatif untuk membantu kumpulan B40 dengan kemahiran dan pengetahuan khusus yang membolehkan mereka meningkatkan pendapatan isi rumah dari pelbagai aktiviti ekonomi",
    title3: "Pembangunan PKS",
    content3:
      "Latihan berstruktur yang diadakan dengan kerjasama dan sokongan pelbagai rakan strategik supaya PKS dapat meningkatkan produktiviti untuk terus kekal berdaya saing di pasaran",
    title4: "Revolusi Perindustrian 4.0",
    content4:
      "Membantu majikan melatih pekerja dalam program latihan berkaitan dengan pendigitalan dan menambah ilmu pengetahuan tentang industri 4.0 dengan mempelajari cara yang lebih fleksibil dan pantas dalam mencipta inovasi baru dalam proses mencipta reka bentuk yang akan memenuhi kehendak pasaran",
    title5: "Gerak Insan Gemilang",
    content5:
      "Gig ekonomi bertujuan untuk memberi kemudahan kepada rakyat Malaysia terutamanya golongan belia dengan kemahiran dan pengetahuan khusus melalui konsep ‘mula ke akhir’ yang membolehkan mereka beroperasi sebagai pekerja bebas untuk menjana pendapatan yang lebih baik dan menguntungkan",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyEcerData = {
    ecerTitle: "Majlis Pembangunan Wilayah Ekonomi Pantai Timur (ECERDC)",
    ecerDescription:
      "Menawarkan program modal insan yang dirancang untuk tujuan penempatan pekerjaan atau penjanaan pendapatan yang tertumpu di Wilayah Ekonomi Koridor Pantai Timur.",
    title1: "Program Peningkatan Bakat ECER , ETEP:",
    titleContent1: "Penempatan dan Latihan",
    content1:
      "Syarikat akan dibantu melalui dasar pembayaran subsidi gaji dalam bentuk pembayaran balik bagi membolehkan pekerja baru yang telah diupah menjalani latihan semasa bekerja",
    title2: "ETEP Enhanced Train & Place (PENJANA)",
    content2:
      "Initiatif untuk memberi peluang latihan kemahiran teknikal kepada kumpulan sasaran untuk meningkatkan kemahiran peribadi mereka dan kebolehpasaran, disusuli oleh tenaga kerja yang sepadan antara syarikat dan peserta.",
    description: "Penerangan:",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyNciaData = {
    nciaTitle: "Pihak Berkuasa Pelaksanaan Koridor Utara (NCIA)",
    nciaContent:
      "Menawarkan program modal insan, penempatan pekerjaan firma yang dirancang atau penjanaan pendapatan yang tertumpu di Wilayah Ekonomi Koridor Utara",
    description: "Penerangan:",
    title1: "JomNiaga@NCER",
    content1:
      "JomNiaga@NCER adalah program modal insan inklusif yang dapat meningkatkan taraf hidup kumpulan B40 di Wilayah Ekonomi Koridor Utara [NCER] melalui latihan dalam kemahiran asas, keusahawanan dan e-dagang.",
    title2: "JomKerja@NCER",
    content2:
      "JomKerja@NCER adalah program modal insan yang direka syarikat firma di Wilayah Koridor Utara [NCER] untuk memberi peluang pekerjaan kepada pekerja yang tidak bekerja dan lepasan sekolah",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static agencyMaraData = {
    maraTitle: "MARA [ Majlis Amanah Rakyat]",
    maraDescription:
      "Memberi pendedahan dan kesedaran melalui Latihan dan kemahiran serta mendidik para peserta untuk memupuk pelbagai nilai keusahawanan dan memilih keusahawanan sebagai pilihan kerjaya mereka",
    description: "Penerangan:",
    title1:
      "Membangun Keupayaan Usahawan Dalaman dengan melibatkan Program e-Dagang [e-usahawan] – Platform Latihan e-Dagang",
    content1:
      "Meningkatkan keupayaan perniagaan sedia ada kepada usahawan yang menggunakan platform e-dagang",
    title2:
      "Membangun Keupayaan Usahawan Dalaman berkaitan e-Dagang di bawah Program Terancang Berstruktur [ e- Usahawan]",
    content2:
      "Jana pendapatan baru dan tingkatkan yang ada dalam aplikasi yang terdapat di pasaran",
    title3:
      "Membangun Keupayaan Usahawan Dalaman dengan Melibatkan Program e-Dagang Terancang melalui [ e-Usahawan ]- Pemecutan Pantas",
    content3:
      "Meningkatkan keupayaan digital usahawan melalui sokongan pendigitalan berstruktur",
    title4:
      "Membangun Keupayaan Usahawan Dalaman dengan melibatkan Program e-Dagang yang Terancang melalui [ e-Usahawan]- Teknikal Gig / e-Hailing",
    content4:
      "Meningkatkan keupayaan perniagaan yang sedia ada kepada usahawan menggunakan platform e-Hailing",
    title5:
      "Membangun Keupayaan dan Menyediakan Pekerjaan Melalui Boot Camp dalam industri",
    content5:
      "Peserta memperoleh sijil kecekapan untuk memenuhi keperluan jawatan dalam industri",
    title6:
      "Membangun Keupayaan dan Meyediakan Pekerjaan Melalui Kompetensi/ Kursus Jangka Pendek",
    content6:
      "Peserta akan mendapat latihan yang diperlukan untuk memenuhi kriteria keperluan jawatan dalam industri",
    title7: "Program TVET Komuniti",
    content7:
      "Latihan kemahiran dalam bidang yang dapat menjana pendapatan perniagaan dalam talian untuk pengusaha tempatan yang mempromosikan produk mereka",
    title8:
      "Pembangunan Usahawan Menggunakan Kaedah Pemasaran Digital /Dalam Talian [ Mahir Niaga]",
    content8:
      "Perniagaan dalam talian kepada pengusaha tempatan untuk mempromosikan produk mereka secara dalam talian",
    title9: "Pusat Sehenti Pengumpulan dan Pegedaran Produk Makanan Sejuk Beku",
    content9:
      "Pusat sehenti untuk menyimpan dan memasarkan produk makanan sejuk beku",
    title10: "Modul Khas Penjagaan Kesihatan dan Keselamatan Kebiasaan Baharu",
    content10:
      "Modul khas rutin kesihatan dan tabiat kesihatan norma baharu dalam pelbagai sector ekonomi dan bidang kemahiran",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static registerCardData = {
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
  };

  public static contactUsData = {
    title: "HUBUNGI KAMI",
    titleDescription: "Ada pertanyaan atau maklum balas untuk kami? Hubungi kami di ibu pejabat atau cawangan kami di sini",
    yourName: "Nama",
    yourEmail: "E-mel",
    subject: "Subjek",
    yourMessage: "Mesej",
    sendMessageButton: "Hantar mesej",
    doYouNeed: "Adakah anda memerlukan sebarang bantuan dari pegawai kami?",
    callUs: "Hubungi kami",
    pleaseContactUs:
      "E-mel Kami",
    registerNowCardText:
      "INGIN MENYERTAI PROGRAM LATIHAN?",
    registerNow: "Daftar sekarang",
    start: "Mulakan perjalanan peningkatan kemahiran anda hari ini​",
    contact: "Hubungi Kami",
    contact1: "Hubungi",
    us: "Kami",
    need: "Perlukan",
    assist: "bantuan?",
    noCourse: "Tiada Kursus Ditemui",
    slots: "Slot",
    courses: "Kursus",
    search: "Pilih kursus di sini",
    courseDetails: "Perincian Kursus",
    startDate: "Mula",
    endDate: "Tamat",
    certificate: "Sijil",
    mode: "Mod Latihan",
    state: "Negeri",
    agency: "Agensi",
    contactNum: "Hubungi",
    pic: "Nama PIC",
    number: "Nombor Telefon",
    email: "E-mel",
    related: "Kursus yang Berkaitan",
    trainers: "Pelatih",
    duration: "Tempoh",
    enroll: "DAFTAR SEKARANG​",
    content: "Kandungan Kursus",
    summary: "Ringkasan Kursus",
    trainingType:"Training Type",
    skillArea:"Bidang Kemahiran",
    hours: "Jam",
    back: "Kembali",
    regopensoon:"Pendaftaran akan dibuka kelak",
    trainingprovider: "Penyedia Kursus",
    coursetype: "Jenis Kursus",
    available_seats: "Tempat Tersedia",
    unlimited_seats: "Tersedia Tanpa Had",
    foc: "PERCUMA",
    description: "Hubungi Kami dan Beritahu Bagaimana Kami Boleh Membantu.",
    address: "Alamat",
  };

  public static insightsData = {
    insightsTitle: "LAPORAN & ARTIKEL",
    title: "Laporan Industri Penyelidikan & Pembangunan",
    description:
      "Laporan Industri Penyelidikan dan Pembangunan bertujuan untuk memberikan maklumat kepada industri yang relevan dan juga masyarakat umum mengenai perkembangan terkini landskap latihan di Malaysia. Laporan ini juga berfungsi sebagai rujukan bagi majikan dan pekerja mengenai keperluan latihan.",
    tab1: "Training Digest",
    tab2: "Laporan Wawasan Industri",
    tab3: "Laporan Pintas HRD Corp",
    tab4: "Laporan Ekosistem Pembelajaran & Tenaga Kerja",
    tab5: "Laporan Penyertaan Latihan Industri (ITP)",
    registerNowCardText:
      "Ingin Menyertai Program Latihan Atau Mencari Pekerjaan?",
    registerNow: "Daftar sekarang",
    training: "Ringkasan ini memberikan maklumat berkala dan ringkas kepada pihak berkepentingan mengenai perkembangan terbaru dalam lanskap latihan.",
    industry: "Laporan Wawasan Industri HRD Corp bertujuan untuk memberi pemahaman kepada pihak berkepentingan mengenai trend dan cabaran latihan yang dihadapi oleh subsektor terpilih.",
    industyTitle: "Laporan Wawasan Industri",
    capital: "Laporan Pintas HRD Corp",
    capitalReport: "Laporan Pintas HRD Corp bertujuan untuk menyediakan analisis data dalaman HRD Corp untuk memberikan pengetahuan.",
    intelligence: "Laporan Ekosistem Pembelajaran & Tenaga Kerja",
    intelligenceReport: "Laporan Modal Insan HRD Corp bertujuan untuk berkongsi perkembangan terkini dalam bidang modal insan dari perspektif HRD Corp.",
    itpReport: "Laporan Penyertaan Latihan Industri (ITP)",
    itpDescription: "Laporan Penyertaan Latihan Industri HRD Corp (ITP) bertujuan untuk memberikan pandangan berharga kepada pihak berkepentingan mengenai landskap penyertaan latihan dari pelbagai industri. Ia memfokuskan pada lima (5) indikator: Tempoh Latihan Berkesan, Nisbah Pekerja Terlatih, Nisbah Peluang Latihan, Tempat Latihan yang Diluluskan, dan Pelaburan Industri pada Latihan menggunakan HRD Corp.",
    resources: "Sumber",
    report: "Laporan & Artikel",
    tag: "Ketahui trend dan perkembangan terkini dalam industri anda",
    research: "Laporan",
    reports: "Penyelidikan & Pembangunan",
    researchSub: "Laporan tersebut memberikan maklumat yang luas mengenai trend terkini dan keperluan latihan untuk pelbagai industri. Ia juga berperanan sebagai rujukan untuk majikan dan pekerja.",
    trainings: "Ringkasan",
    digest: "Latihan",
    start: "Mulakan perjalanan peningkatan kemahiran anda hari ini​",
    download: "Muat turun",
  };

  public static searchJobData = {
    jobSearch: "Pencarian Kerja",
    recentJobListing: "Senarai Pekerjaan Terkini",
    applyNow: "Pohon sekarang",
    searchSkillsPH: "Carian skil , Tajuk pekerjaan",
    jobTitle: "Tajuk pekerjaan",
    location: "Lokasi",
    advanceSearch: "Carian maju",
    logout: "Log keluar",
    strategicPartners: "Rakan Strategik",
    viewJobPost: "Lihat Jawatan Kerja",
  };

  public static employerSignupData = {
    heading: "Maklumat Asas Anda",
    subHeading: "Daftar secara percuma untuk mencari calon yang sesuai.",
    employName: "Nama Majikan",
    phoneNo: "Nombor Telefon",
    placePhoneNo: "Masukkan nombor telefon",
    emailAddress: "Alamat E-mel",
    createPassword: "Reka kata laluan",
    agreeRecive: "Saya bersetuju untuk menerima sebarang notifikasi dari HRD Corp.",
    agree: "Saya bersetuju dengan",
    terms: "terma dan syarat",
    hrdf: "oleh HRD Corp.",
    getStarted: "Klik dan mulakan",
    register: "Berdaftar",
    nonregister: "Tidak Berdaftar",
    companyName: "Nama Syarikat",
    placeCompanyName: "Masukkan nama syarikat",
    companyRegNo: "Nombor Pendaftaran Syarikat",
    placeCompanyRegNo: "Masukkan nombor pendaftaran syarikat",
    noOfEmpoly: "Bilangan Pekerja",
    placeNoOfEmpoly: "Masukkan bilangan pekerja",
    companySize: "Saiz Syarikat ",
    placecompanySize: "Saiz Syarikat ",
    companyInfo: "Maklumat Syarikat",
    placecompanyInfo: "Taip informasi syarikat",
    digitalUrl: "Informasi Digital/URL",
    placedigitalUrl: "Masukkan informasi digital /URL",
    industry: "Industri",
    placeIndustry: "Pilih jenis industri",
    address: "Alamat",
    placeAddress: "Masukkan alamat anda",
    city: "Bandar",
    placeCity: "Masukkan lokasi anda",
    state: "Negeri",
    placeState: "Pilih negeri",
    postCode: "Poskod",
    placePostCode: "Masukkan Poskod",
    subSector: "Sub-sektor",
    placeSubSector: "Masukkan Sub-sektor",
    uploadLogo: "Muat naik logo",
    placeUpload: "Muat naik logo syarikat anda",
    createAccount: "Daftar Akaun",
  };

  //Jobseeker Dashboard
  public static jobSeekerDashboard = {
    profile: "Profil",
    editProfile: "Sunting Profil",
    postedJob: "Pekerjaan Dimuatnaikkan",
    recomJob: "Pekerjaan Dicadangkan",
    appliedJobs: "Pekerjaan Dipohon",
    interview: "Jumlah Temuduga",
    programs: "Program Yang Tersedia",
    courses: "Kursus Ditawarkan",
    recomCourse: "Kursus Dicadangkan",
    courseApplied: "Kursus Disertai",
    jobRecom: "Cadangan Pekerjaan",
    recomCourses: "Cadangan Kursus",
    appliedCourseTitle: "Kursus Dipohon",
    viewMore: "Banyak lagi",
    Strategik: "Rakan Strategik",
    allCourses: "Semua Kursus",
    completed: "Kursus Selesai",
    noCourse: "Tiada Kursus Selesai",
    noApplied: "Tiada Kursus Disertai​",
    slots: "Slot",
    available_seats: "Tempat Tersedia",
    unlimited_seats: "Tersedia Tanpa Had",
    foc: "PERCUMA",
    eLearning: "E-PEMBELAJARAN",
    eLearningDesc: "Lebih daripada 55,000 kursus percuma ditawarkan di dalam portal NTW",
  };

  //jobseeker Profile Page

  public static jobSeekerProfile = {
    quickLink: "Rangkaian pantas",
    attachMent: "Lampirkan Maklumat Peribadi",
    uploadResume: "Muat Naik Maklumat Peribadi",
    format: "Format yang disokong pdf hingga 2MB",
    resumeHeadLine: "Teruskan Tajuk Utama",
    keySkills: "Kemahiran Utama",
    employment: "Maklumat Pekerjaan",
    addEmployment: "Tambah Pengambilan Pekerjaan",
    projects: "Projek",
    addProjects: "Tambah Projek",
    education: "Latar Belakang Pendidikan",
    addeducation: "Tambah Pendidikkan",
    conditionQus: "Soalan Penyesuaian",
    addconditionQus: "Tambah Soalan Penyesuaian",
    profileSummary: "Ringkasan Profil",
    assessmentResult: "Hasil Penilaian",
    takeTest: "Ikuti Ujian",
    jobPreferences: "Keutamaan pilihan pekerjaan",
    industry: "Industri",
    workPosition: "Kedudukan Kerja",
    jobCategory: "Kategori Kerja",
    employmentType: "Jenis  Pekerjaan",
    desiredShift: "Pilihan masa bekerja",
    personalDetails: "Maklumat Peribadi",
    dob: "Tarikh Lahir",
    gender: "Jantina",
    maritalStatus: "Status Perkahwinan",
    city: "Daerah / Bandar",
    postcode: "Poskod",
    add: "Tambah",
    update: "Kemaskini",
    resumeDes:
      " Resume adalah dokumen penting yang dilihat oleh bakal majikan/perekrut.",
    attachVideo: "Muat naik video",
    videoDes:
      " Hanya MP4, WEBM, M4P, M4V, AVI, WMV, MOV, FLV dan MPEG sahaja, saiz dokumen sehingga 30 MB yang dibenarkan",
    uploadVideo: "Muat naik video",
    upload: "Muat naik",
    email: "Alamat E-mel",
    phone: "Nombor Telefon",
    ic: "Nombor Kad Pengenalan",
    profile: "Ringkasan Profil",
    skills: "Kemahiran",
    experience: "Pengalaman",
    completed: "Kursus Selesai",
    personal: "Butiran Peribadi",
    notComplete: "Tiada Kursus Selesai",
    passport : 'Nombor Passport',
    ethnic : 'Etnik',
  };

  //indSF

  public static industrialSkilsData = {
    headingINDSF: "KERANGKA KEMAHIRAN",
    framework: " INDUSTRI",
    overView: "TINJAUAN KESELURUHAN",
    overViewSub:
      "Kerangka Kemahiran Industri (IndSF) adalah inisiatif di bawah empat tonggak utama peta strategi inisiatif HRD Corp. Ia diletakkan di bawah ekosistem pembelajaran dan lanskap kerana sifat dokumen yang tidak lengkap dan mempromosikan kitaran pembelajaran berterusan antara majikan, pekerja dan pencari kerja yang berpotensi. Dokumen ini akan dikaji dari semasa ke semasa untuk memenuhi keperluan semasa industri dari segi kemahiran dan kecekapan teras.",
    itCover: "APA YANG DISEDIAKAN?",
    itCoverSub:
      "IndSF memberi tumpuan terutamanya pada Sijil Kemahiran Malaysia Tahap 4 atau setaraf dan lebih tinggi sebagai dokumen percuma untuk kerangka kerja yang ada seperti Standard Kemahiran Pekerjaan Negara.",
    whoIsItFor: "INI UNTUK SIAPA?",
    employee: "INDIVIDU / PEKERJA",
    employeeSubContent:
      "Individu di awal  atau pertengahan kerjaya mereka dapat menggunakan Kerangka Kemahiran untuk membuat keputusan yang tepat mengenai pendidikan dan latihan, pengembangan kerjaya dan peningkatan kemahiran berdasarkan sektor, pekerjaan, pekerjaan / peranan pekerjaan, kemahiran dan maklumat latihan dalam kerangka.",
    employers: "PEKERJA",
    employersSubContent:
      "Majikan boleh menggunakan Kerangka Kemahiran untuk merancang rancangan pengurusan sumber manusia dan pengembangan bakat yang progresif berdasarkan maklumat kemahiran terperinci dalam kerangka tersebut.",
    agency: "PENYEDIA AGENSI / LATIHAN",
    agencySubContent:
      "Penyedia Latihan boleh menggunakan Kerangka Kemahiran untuk mendapatkan pandangan mengenai tren sektor dan kemahiran dalam permintaan, yang memungkinkan mereka untuk berinovasi dan mengkontekstualisasikan rancangan kurikulum dan program latihan mereka agar sesuai dengan keperluan sektor tersebut.",
    componentsTitle: "KOMPONEN",
    jobSkills: "PENERANGAN KERJA & KEMAHIRAN",
    jobSkillsSubContent:
      "Peta Kemahiran memperincikan kemahiran untuk setiap pekerjaan industri, selaras dengan bidang / bidang fokus / bahagian / bahagian kritikal. Ia memberikan maklumat seperti keterangan dan kemahiran pekerjaan)",
    careerPathway: "JALAN KERJAYA",
    careerPathwaySubContent:
      "Laluan Kerjaya menunjukkan bagaimana pekerjaan dalam Kerangka Kemahiran Industri untuk industri disusun secara progresif dan lateral berdasarkan norma sektor",
    trainingProgrammes: "PROGRAM LATIHAN",
    trainingProgrammesSub:
      "Program Latihan memberikan maklumat mengenai pemerolehan kemahiran yang tersedia untuk pendatang baru dan kakitangan dalam perkhidmatan untuk memperoleh kemahiran dan kecekapan yang diperlukan untuk pelbagai pekerjaan di Industri.",
    indSFSectors: "IndSF oleh Sektor:",
    plastics: "Plastik",
    machineryEquipment: "Mesin & Peralatan",
    dataScience: "Bakat Digital: Sains Data",
    cybersecurity: "Bakat Digital: Keselamatan siber",
    games: "Bakat Digital: Permainan",
    animation: "Bakat Digital: Animasi",
    frontOffice: "Keramahan: Kakitangan Barisan Hadapan",
    housekeeping: "Keramahan: Pengemasan Persekitaraan Organisasi",
    revenueManagement: "Keramahan: Pengurusan Hasil",
    salesMarketing: "Keramahan: Penjualan ,Promosi & Pemasaran",
    hotel: " Keramahan: Pengurusan Hotel & Umum",
    oilGas: "Minyak, Gas & Tenaga",
    wholesaleRetail: "Borong & Runcit",
    resource: "Sumber",
    skill: "Industri Kerangka Kemahiran",
    develop: "Kembangkan bakat untuk keperluan industri",
    over: "Gambaran",
    view: "Keseluruhan",
    overViewSub2: "Kerangka Kemahiran Industri (IndSF) adalah rangkaian dokumen yang dibangunkan oleh HRD Corp dengan kerjasama rakan industri untuk mengenal pasti kemahiran dan kecekapan keperluan pelbagai industri.​",
    area: "Rangkuman",
    covered: "Bidang",
    areaSub: "IndSF memberi tumpuan kepada Persijilan Kemahiran Malaysia Tahap 4, setaraf atau tahap seterusnya. Ia juga berfungsi sebagai dokumen pelengkap kepada kerangka kerja yang ada seperti Standard Kemahiran Pekerjaan Kebangsaan (NOSS).​",
    target: "Kumpulan",
    audience: "Sasaran",
    individual: "Individu atau Pekerja​",
    individualSub: "Membolehkan individu membuat keputusan yang tepat mengenai perancangan pendidikan dan pensijilan mereka, di samping mengenal pasti latihan dan peningkatan kemahiran yang diperlukan untuk pengembangan kerjaya mereka.",
    employer: "Majikan",
    employerSub: "Merancang program pengurusan sumber manusia yang progresif, serta mengembangkan perancangan penggantian dan peta jalan kerjaya untuk pekerja semasa dan masa hadapan.",
    training: "Penyedia Latihan",
    trainingSub: "Dapatkan pandangan mengenai trend sektor dan kemahiran yang diperlukan untuk berinovasi dan meningkatkan program bagi memenuhi bakat dan keperluan industri.",
    key: "Elemen",
    component: "Utama",
    job: "Gambaran Pekerjaan & Kemahiran",
    jobSub: "Menggariskan kemahiran yang diperlukan untuk setiap pekerjaan industri. Selaras dengan bidang kritikal, bidang tumpuan, jabatan atau bahagian. Ia juga mengariskan penerangan kerja terperinci untuk setiap peranan.",
    career: "Perjalanan Karier",
    careerSub: "Merangkumi bagaimana pekerjaan dalam dokumen disusun secara progresif dan lateral berdasarkan norma sektor serta pengalaman dan kompetensi yang diperlukan.",
    programme: "Program Latihan",
    programmeSub: "Menyampaikan maklumat mengenai jenis program latihan, tahap pensijilan dan jangka masa yang tersedia untuk pelbagai peranan dalam industri.",
    sectors: "Mengikut Sektor",
    start: "Mulakan perjalanan peningkatan kemahiran anda hari ini​",
    registerNow: "Daftar sekarang",
    
  };

  public static mediaGallery = {
    mediaGalleryTitle: "GALERI MEDIA",
    video: "VIDEOS",
    publication: "PENERBITAN",
  };

  public static jobseekerLoginData = {
    welcome: "Selamat kembali!",
    pleaseLoginHeading: "Sila log masuk menggunakan maklumat peribadi yang telah anda daftarkan semasa pendaftaran.​",
    pleaseLoginHeading2: "Pengguna ",
    pleaseLoginHeadingWith: "pencari kerja / pengguna platform HPC, Upskill dan MYHRDCORP Super App ",
    pleaseLoginHeading3: "boleh log masuk menggunakan kelayakan sedia ada.​",
    email: "Alamat E-mel",
    password: "Kata Laluan",
    ic:'IC',
    enterPassword: "Masukkan kata laluan",
    enterIC: "Masukkan No. MyKad",
    //forgotPassword: "Masalah semasa log masuk? Tekan di sini.",
    forgotPassword1: "Tidak dapat log masuk?",
    forgotPassword: "Klik di sini.",
    login: "Log Masuk",
    dontHaveAccount: "Tidak mempunyai akaun Individu?",
    joinNow: "Daftar Sekarang",
    needHelp: "Perlu bantuan?",
    contactUs: "Hubungi Kami​",
    empowering: "Memperkasakan diri dengan peningkatan kemahiran yang berterusan​",
    emailPlace: "E-mel",
    forgot: "Terlupa Kata Laluan?",
    send: "Hantar butiran",
    credentials: "Pencari kerja/pengguna berdaftar dalam platform HPC/Upskill/MyHRDCORP Super App boleh log masuk menggunakan butiran log masuk sedia ada.",
    continueWith: "atau sambung dengan",
  };

  public static employerLoginData = {
    pleaseLoginHeading: "Sila log masuk ke akaun anda",
    email: "Alamat E-mel",
    password: "Kata Laluan",
    enterPassword: "Masukkan kata laluan anda",
    forgotPassword: "Terlupa Kata Laluan?",
    login: "Log Masuk",
    dontHaveAccount: "Tidak mempunyai akaun Majikan di UpskillMalaysia?",
    joinNow: "Daftar Sekarang",
    needHelp: "Perlukan Bantuan?",
    contactUs: "Hubungi Kami",
    register: "Berdaftar",
    nonregister: "Tidak Berdaftar",
  };

  public static innerpageData = {
    bannerText: "Kejar Kerjaya Impian Anda Dengan Memilih Program Latihan Berstruktur yang Bersesuaian dengan Anda",
    bannerTextsub: "Ringkas dan Mudah",
    courseSearch: "Carian Kursus",
    first: "MULAKAN LANGKAH ANDA",
    register: "Mendaftar",
    info: "Isikan Maklumat",
    search: "Mulakan Pencarian",
    apply: "Mohon",
    personalInfo: "Lengkapkan maklumat peribadi anda dan ketahui cadangan kursus yang bersesuaian berdasarkan minat dan keperluan unik anda.",
    find: "INGIN MENYERTAI PROGRAM LATIHAN?",
    registerNow: "DAFTAR SEKARANG",
    viewAll: "Papar Semua Kursus",
    location: "Pilih Lokasi",
    category: "Pilih Bidang",
    skills: "Pilih Bidang Kemahiran",
    applyNow: "Mohon Sekarang",
    viewDetails: "Lihat Butiran",
  };

    // Jobseeker profile Employment Form

    public static employmentformText = {
      addemployment: "Tambah Pekerjaan",
      editemployment: "Edit Pekerjaan ",
      designation: "Jawatan Anda ",
      designationplaceholder: "Jawatan Anda",
      organization: "Organisasi Anda ",
      organizationplaceholder: "Organisasi Anda ",
      positionlevel: "Tahap Kedudukan ",
      positionlevelplaceholder: "Pilih Tahap kedudukan anda",
      specialization: "Pengkhususan ",
      specializationplaceholder: "Pilih Pengkhususan ",
      role: "Peranan ",
      roleplaceholder: "Pilih Peranan",
      jobcatagory: "Kategori Kerja ",
      jobcatagoryplaceholder: "Pilih Kategori Kerja Anda",
      typesofjob: "Jenis Pekerjaan ",
      typesofjobplaceholder: "Pilih Jenis Pekerjaan Anda",
      currentcompany: "Adakah ini syarikat anda sekarang? ",
      yes: "Ya ",
      no: "Tidak ",
      startdate: "Mula Bekerja Dari ",
      enddate: "Bekerja Hingga ",
      monthlysalary: "Gaji bulanan ",
      location: "Lokasi ",
      locationplaceholder: "Masukkan Lokasi Anda",
      state: "Negeri ",
      stateplaceholder: "Pilih Negeri ",
      outsidemalaysia: "Di luar Malaysia ",
      jobprofile: "Terangkan Profil Pekerjaan anda ",
      typehere: "Taip di sini ",
      noticeperiod: "Tempoh notis ",
      noticeperiodplaceholder: "Pilih Tempoh notis ",
      industry: "Industri ",
      industryplaceholder: "Pilih Industri",
      cancelbtn: "Batalkan",
      savebtn: "Simpan",
      updatebtn: "Kemas kini",
      retrenched: "Saya telah diberhentikan kerja",
    };

  // Jobseeker Profile Education Form
  public static educationformText = {
    addEducation: "Tambah pendidikan",
    selecteducation: "Pilih Pendidikan",
    educationqualification: "Kelayakan Tertinggi",
    educationsubcatagory: "Sub-Kategori pendidikan",
    educationsubcataselect: "Pilih Kategori Pendidikan",
    fieldOfStudy: "Bidang pengajian",
    selectfieldofstudy: "Pilih Bidang pengajian",
    university: "Universiti / Kolej",
    enterunicollege: "Masukkan Universiti / Kolej anda",
    specialisation: "Pengkhususan",
    selectspecial: "Pilih Pengkhususan",
    specialisationsubCatagory: "Sub-Kategori Pengkhususan ",
    selectspecialcata: "Pilih Pengkhususan-sub kategori",
    courseType: "Jenis Kursus",
    select: "Pilih",
    graduationTime: "Tarikh lulus",
    gradingsystem: "Sistem penggredan ",
    selectgradsystem: "Pilih Sistem Penggredan",
    cgpamark: " CGPA / Gred / Markah",
    entercgpa: "Masukkan CGPA / Gred / Markah",
    cancelbtn: "Batalkan",
    savebtn: "Simpan",
    fulltime: "Sepenuh Masa",
    parttime: "Sambilan",
    distancelearning: "Pembelajaran Jarak Jauh",
    editeducation: "Suntingan Pendidikan",
    updatebtn: "Kemas kini",
  };

    // Persona Detail Form Jobseeker

    public static personaldetailtext = {
      personaldetailheader: "Maklumat kendiri",
      dateofbirth: "Tarikh Lahir",
      gender: "Jantina",
      male: "Lelaki",
      female: "Perempuan",
      address: "Alamat",
      city: "Bandar",
      state: "Negeri",
      postcode: "Poskod",
      ethnicity: "Kaum",
      maritalstatus: "Status Perkahwinan",
      cancelbtn: "Batalkan",
      savebtn: "Simpan",
      successalerthead: "Berjaya",
      successalert:
        "Perincian peribadi telah berjaya dimuat naik di dalam profil anda",
      dob: "Tarikh Lahir",
      adPlaceholder: "Masukkan Alamat",
      cityPlaceholder: "Masukkan Daerah/Bandar",
      statePlaceholder: "Pilih Negeri",
      postcodePlaceholder: "Masukkan Poskod",
      ethnicityPlaceholder: "Pilih Kaum",
      statusPlaceholder: "Pilih Negeri",
    };

    public static popupText = {
      success: "Berjaya",
      error: "Ralat",
      addEmployeeSuccess: "Pendaftaran anda berjaya",
      addEmployeeFail: "Pendaftaran anda tidak berjaya, sila cuba lagi",
      updateJobseekerSuccess: "Akaun ini berjaya dipautkan dengan pekerja ",
      updateJobseekerFail: "Akaun ini tidak dapat dipautkan dengan pekerja.",
      addEmployerSuccess: "Majikan telah berjaya disimpan dalam senarai",
      addEmployerFail:
        "Majikan tidak berjaya disimpan dalam senarai. Sila cuba lagi",
      addJobPostSuccess: "Jawatan kerja telah berjaya disiarkan",
      addJobPostFail: "Jawatan kerja tidak berjaya disiarkan. Sila cuba lagi..",
      advanceSearchError: "Sila masukkan kata kunci.",
      advertisementUploadSuccess: "Iklan telah dimuat naik.",
      advertisementUploadErr: "Iklan tidak dimuat naik.",
      advertisementUploadErrFile: "Saiz fail tidak boleh melebihi 1MB",
      advertisementUploadErrFileFrmt:
        "Iklan hanya menerima format fail jpg, jpeg dan png",
      errFileSize2MB: "Saiz fail tidak boleh melebihi 2MB.",
      errFileSize30MB: "Saiz fail tidak boleh melebihi 30MB.",
      editEmployerErrFileFrmt:
        "Logo hanya menerima format fail jpg, jpeg dan png",
      updateEmployerSuccess: "Profil majikan telah dikemas kini.",
      updateEmployerErr: "Profil majikan belum dikemas kini.",
      updateJobPostSuccess: "Jawatan kerja berjaya dikemas .",
      updateJobPostErr: "Jawatan kerja belum dikemas kini.",
      invalidCredential: "Maklumat tidak sah !",
      usernotfound: "Pengguna tidak ada dalam sistem!!",
      couldnotlogin: "Tidak dapat log masuk… ",
      onlyIndLogin: "Hanya individu yang log masuk…",
      accntdeactivated: "Akaun anda telah dinyahaktifkan. Sila hubungi pentadbir",
      accntActivateEmail: "Aktifkan akaun anda melalui E-mel.",
      updateEmployerStatusSucess: "Status majikan telah berjaya dikemaskini.",
      updateEmployerStatusErr: "Status majikan tidak ada penukaran",
      logoUploadFileSizeErr: "Saiz fail tidak boleh melebihi 2MB.",
      logoUploadFileFrmt: "Logo hanya menerima format fail jpg, jpeg dan png",
      createEmployerSuccess: "Pendaftaran anda Berjaya!",
      createEmployerErr: "Majikan tidak berdaftar.",
      inviteCandidateForJobSuccess:
        "Permohonan pekerjaan calon telah diterima. Calon akan dimaklum tidak lama lagi",
      inviteCandidateForJobNotInvite: "Permohonan pekerjaan calon tidak berjaya",
      inviteCandidateForJobChoose: "Sila pilih jemputan permohonan pekerjaan.",
      noconditionalquestions:
        "Tiada soalan bersyarat yang disediakan untuk kursus ini.",
      applycourseemploye: "Kursus yang digunakan untuk pekerja..",
      unabletoprocess:
        "Kami tidak dapat memproses permohonan ini. Sila cuba lagi.",
      selectEmployee: "Sila pilih calon untuk permohonan.",
      maxemployee: "Permohonan ini hanya terhad untuk 100 calon. ",
      resumeUploadFileSize: "Saiz fail melebihi ",
      resumeUploadFileFrmtXlsx: "Resume hanya menerima format fail xlsx.",
      resumeUploadFileFrmtPdf: "Resume hanya menerima format fail pdf. ",
      uploadEmployeeExceedLimit:
        "Sila muat naik fail dengan jumlah baris tidak melebihi 100.",
      uploadEmployeeExceedSuccess: "Pekerja berjaya dimuat naik.",
      deletejobPostsSuccess: "Jawatan Kerja berjaya disingkirkan.",
      deletejobPostsErr: "Jawatan Kerja tidak disingkirkan ",
      updatePostjobStatusSuccess: "Status jawatan kerja telah dikemaskini.",
      updatePostjobStatusErr: "Status jawatan kerja tidak berubah. ",
      jobseekerDeactivates: "Calon ini dinyahaktifkan.",
      coudlnotreset: "Tidak dapat set semula kata laluan.",
      updatePasswordEmployerSuccess: "Kata laluan majikan telah dikemas kini.",
      updatePasswordEmployerErr: "Kata laluan majikan belum dikemas kini.",
      resetEmployerPassword: "Tidak dapat set semula kata laluan. ",
      applyJobpostByJobseekerSuccess: "Permohonan telah di hantar kepada majikan",
      applyJobpostByJobseekerPosClosed:
        "Dengan duka citanya kami ingin memaklumkan bahawa permohonan di atas telah ditutup dalam sistem kami. Kami ingin mengucapkan tahniah kepada mereka yang telah terpilih untuk jawatan ini. ",
      applyJobpostByJobseekerErr: "Pekerjaan belum dipohon.",
      saveJobSuccess: "Jawatan telah di simpan",
      saveJobErr: "Jawatan telah di padam",
      interviewScheduleAccept: "Jadual bagi temuduga anda telah di terima.",
      interviewScheduleDecline: "Jadual bagi temuduga anda telah di tolak",
      interviewScheduleNtAccept: "Jadual temu ramah tidak berjaya diterima",
      interviewScheduleNtRej: "Jadual temu ramah tidak ditolak",
      uploadPdfFrmt: "Sila muat naik fail berformat pdf sahaja",
      resumeuploaded: "Resume anda telah dimuat naik",
      resumenotupdated: "Resume tidak/belum dikemas kini ",
      resumefilefrmts:
        "Resume hanya menerima fail berformat MP4, WEBM, M4P, M4V, AVI, WMV, MOV, FLV dan MPEG",
      videouploadedsuccess: "Video anda berjaya dimuat naik ",
      videouploaderr: "Video anda tidak berjaya dimuat naik ",
      empdtlsdelsuccess:
        "Maklumat pekerjaan/kerjaya anda telah dipadam di dalam profil",
      empnotdel: "Maklumat pekerjaan/kerjaya tidak dipadam di dalam profil ",
      edudtlsdeleSuccess:
        "Maklumat pendidikan anda telah dipadam di dalam profil ",
      educationnotdel: "Maklumat pendidikan tidak dipadam di dalam profil",
      conditonalqnsdelsuccess: "Soalan bersyarat telah dipadam di dalam profil",
      conditonalqnsntdel: "Soalan bersyarat tidak dipadam di dalam profil ",
      projdtlsdelsuccess: "Maklumat projek anda telah dipadam di dalam profil",
      projntdel: "Maklumat projek tidak dipadam di dalam profil ",
      statusupdatedsuccess: "Status berjaya dikemas kini",
      statusntupdate: "Status belum dikemas kini ",
      registrationntsuccess: "Pendaftaran anda tidak berjaya, sila cuba lagi ",
      registrationsuccess: "Pendaftaran anda berjaya. ",
      uploadfrmts: "Sila muat naik hanya fail berformat jpg, jpeg dan png ",
      hrregsuccess: "Pengguna HR telah berjaya didaftarkan ",
      hrntreg: "Pengguna HR tidak berjaya didaftarkan ",
      empntreg: "Majikan tidak berdaftar ",
      uploadxlsxfrmt: "Sila muat naik fail berformat xlsx sahaja",
      employeentupload: "Pekerja/Calon belum dimuat naik",
      couldntgtemail:
        "Tidak dapat menemui ID e-mel dari akaun anda. Sila cuba lagi dengan akaun lain ",
      accountntreg: "Akaun ini tidak berdaftar di bawah HRD Corp ",
      emailsntsuccess: "Surat telah dihantar kepada Majikan dengan jayanya !! ",
      employerdelsuccess: "Majikan telah berjaya dipadamkan/disingkirkan ",
      employerntdel: "Majikan tidak berjaya dipadamkan/disingkirkan",
      employerntdenied: "Majikan belum ditolak ",
      employerntapprov: "Majikan belum diluluskan ",
      employerdenied: "Majikan berjaya ditolak ",
      employerapprov: "Majikan telah berjaya diluluskan ",
      candidateuploaderr: "Muat naik calon telah gagal  ",
      candidateuploadsuccess: "Muat naik calon telah berjaya ",
      jspassswdntupd: "Kata laluan calon/pencari kerja belum dikemaskini ",
      compprof: "Sila lengkapkan profil anda sebelum meneruskan ",
      crseapplied: "Pendaftaran kursus telah berjaya",
      onecrseattime:
        "Anda hanya di benarkan untuk mendaftar bagi satu kursus sahaja, sila hubungi pihak agensi untuk maklumat lanjut.",
      anscondqns: "Sila jawab Soalan Bersyarat pada profil anda.",
      updcareercoachsucc:"Jurulatih Kerjaya Dikemas kini dengan jayanya",
      addcareercoachsucc:"Jurulatih Kerjaya Dicipta dengan Berjaya",
      addcareercoacherr:"Jurulatih Kerjaya belum dibuat",
      loginTitle: "Selamat kembali, sila log masuk ke akaun anda.",
      emailId: "Alamat email",
      password: "Kata Laluan",
      emailPlaceholder: "contoh@email.com",
      passwordPlace: "Masukkan kata laluan anda",
      forgotPassword: "Lupa Kata Laluan",
      donothaveAccount: "Belum mempunyai akaun Pencari Kerja?",
      loginBtn: "Log masuk",
      joinNow: "Daftar Sekarang",
      needHelp: "Perlukan Bantuan? ",
      contactUs: "Hubungi Kami",
      invalidCredentails: "Kelayakan tidak sah!",
      notApprovedYet: "Akaun anda belum diluluskan!",
      myBasicInfo: "Maklumat Asas Peribadi",
      steps: "Langkah 1 dari 2",
      signupfree: "Pendaftaran Percuma",
      name: "Nama",
      namePlace: "Masukkan nama mengikut kad pengenalan",
      nameErr: "Bidang 'Nama' ini wajib diisi",
      mobileNum: "Nombor telefon",
      mobileNumPH: "masukkan nombor telefon",
      mobileNumErr: "Bidang 'Nombor Telefon' ini wajib diisi",
      icNumberErr: "Bidang 'No. Kad Pengenalan' ini wajib diisi",
      icNumberErr2: "No. Kad Pengenalan ini telah berdaftar!",
      address: "Alamat",
      addressPH: "Alamat",
      addressErr: "Bidang 'Alamat' ini wajib diisi",
      emailErr: "Bidang 'E-mel ID' ini wajib diisi",
      emailErr2: "E-mel ID ini telah berdaftar!",
      city: "Daerah / Bandar",
      cityPH: "Daerah / Bandar",
      cityErr: "Bidang 'Bandar' ini wajib diisi",
      state: "Negeri",
      statePH: "Pilih negeri",
      stateErr: "Bidang 'Negeri' ini wajib diisi",
      postCode: "Poskod",
      placePostCode: "Masukkan Poskod",
      postCodeErr: "Bidang 'Poskod' ini wajib diisi",
      step2: "Langkah 2 dari 2",
      currentCompany: "Syarikat Semasa:",
      currentCompanyPH: "Masukkan nama syarikat semasa anda",
      specialization: "Pengkhususan: ",
      specializationPH: "Pilih Pengkhususan",
      specializationErr: "Bidang 'Pengkhususan' ini wajib diisi",
      jobDesignation:"Nama Pekerjaan",
      jobDesignationPH: "Masukkan Nama Pekerjaan Anda",
      profilePic: "Gambar Profil: ",
      profilePicError: "Sila Muat Naik Gambar Profil Anda",
      motivation: "Penerangan Ringkas dan motivasi anda untuk Bimbingan Kerjaya",
      motivationErr: "Medan Penerangan Ringkas diperlukan",
      certificate: "Persijilan berkaitan Kejurulatihan / Latihan:",
      certificatePH: "Kejurulatihan / Latihan",
      certificateUpload: "Muat Naik Sijil",
      certificates: "Pensijilan",
      slots: "Jumlah slot:",
      slotsPH: "Jumlah slot",
      slotsErr: "Bidang 'Jumlah Slot' ini wajib diisi",
      firstP: "HRD Corp Bimbingan Kerjaya disediakan bagi pencari kerja dari semua peringkat umur dari lepasan sekolah,penganggur graduan dan pekerja yang diberhentikan.",
      secondP: "Adakah anda yakin untuk melatih pencari kerja, terutama pekerja yang diberhentikan yang mempunyai pengalaman kerja yang luas dan jauh lebih tua daripada demografi lepasan sekolah dan penganggur graduan?",
      yes: "Ya ",
      no: "Tidak ",
      concern: "Jelaskan kebimbangan dan keraguan anda.",
      concernErr: "Bidang 'Soalan atau Kebimbangan' ini wajib diisi",
      conditionErr: "Bidang 'Terma & Syarat' ini wajib diisi",
      language: "Bahasa",
      selectErr: "Sila Pilih Salah Satu Bahasa",
      availability: "Yang tersedia: ",
      daysErr: "Sila Pilih Salah Satu Hari",
      time: "Masa dari",
      timeErr1: "Sila Pilih Masa dari",
      timeTo: "Masa hingga",
      timeErr2: "Sila Pilih Masa Sehingga",
      resume: "Muat naik Profil / Resume",
      uploadErr: "Sila Muat Naik Resume",
      confirmationCareerCoach: "Sila ke bahagian seterusnya sekiranya maklumat yang diisi tepat",
      days: "Hari",
      chooseBtn: "Pilih",
      createAccount: "Buat Akaun",
      backBtn: "Kembali",
      getStartedBtn: "Teruskan",
      add: "Tambah",
      enterDetails: "Masukkan butiran untuk Mendaftar",
      reserveBtn: "Tempah tempat saya",
      mydetails: "Maklumat Diri",
      careerDetails: "Maklumat Kerjaya ",
      languagesAble: "Bahasa yang digunakan untuk Bimbingan Kerjaya?",
      cancel: "Pembatalan",
      nextbtn: "Teruskan",
      updateDone: "Kemas kini Profil",
      confirmation: "Pengesahan",
      uniqueIdErr: "E-mel, Nric dan Nombor telefon mesti unik",
      alert: "Perhatian",
      ok: "okey",
      inprogress: "pencari kerja mempunyai permohonan dalam proses",
      slotNotAvailable: "There is no slots available for this careercoach B",
      ccNotApplied: "Jurulatih Kerjaya belum Diterapkan",
      yourAppInProgress: "Permohonan Anda Sudah Berlangsung",
      successApplied: "Jurulatih Kerjaya berjaya dilamar",
      slotsNotAvailable: "Tidak ada slot yang tersedia untuk jurulatih kerjaya ini",
      statusChange: "Status Jurulatih Kerjaya Berubah Berjaya",
      jobseekerAssigned: "Pencari Kerja Berjaya Ditugaskan",
      applicationNotupdated: "Permohonan belum ditugaskan",
      deleteSuccess: "Jurulatih Kerjaya Dihapus dengan Berjaya",
      notDeleted: "Jurulatih Kerjaya belum dipadamkan",
      sessionSchedule: "Jadual Sesi Diterima dengan Berjaya.",
      sessionRejected: "Jadual Sesi Ditolak.",
      sessionNotUpdated: "Jadual Sesi belum dikemas kini",
      jobseekerCoached: "Kerja Telah Dilatih",
      jobseekerApplied: "Kerja Telah Memohon",
      select: "Pilih",
      close: "Pembatalan",
    };

    public static courseListData = {
      courses: "Kursus",
      courseTag: "Tingkatkan pengetahuan dalam bidang kemahiran pilihan anda",
      search: "Carian kursus",
      skillArea: "Bidang Kemahiran",
      sortby: "Susun mengikut",
      filterby: "Tapis mengikut​",
      accounting: "Perakaunan & Kewangan​",
      statistics: "Aktuari atau Statistik",
      admin: "Pengurusan atau Perkeranian​",
      tax: "Audit atau Cukai",
      aviation: "Penerbangan",
      chemistry: "Bioteknologi atau Kimia​",
      more: "Lebih",
      training: "Rakan Latihan (dari A hingga Z)",
      courseTitle: "Tajuk Kursus (dari A hingga Z)​",
      courseDuration: "Tempoh Kursus (dari paling pendek hingga paling panjang)​",
      courseAvailability: "Ketersediaan Kursus",
      courseFee: "Yuran Kursus (dari terendah hingga tertinggi)​",
      startDate: "Tarikh Mula Kursus",
      all: "Semua",
      partnership: "Dengan kerjasama",
      applyCourse: "Kursus Disertai",
      applied: "DIMOHON",
      applyNow: "MOHON SEKARANG",
      pending : "Dalam proses",
      approved: "Diluluskan",
      reject: "Ditolak",
      progress: "Sedang Berjalan",
      withdraw: "Tarik Diri",
      completedPlaced: "Selesai dan Ditempatkan",
      genCert: "Jana Sijil",
      teeAssessment: "Penilaian TEE",
      applied1: "Dipohon",
      first: "Terkini Pertama",
      trainingPlaceholder: "Pilih",
      completed:"Selesai",
      noCourse: "Tiada Kursus Ditemui",
      noApplied: "Tiada Kursus Disertai​",
      clear: "Tetapan Semula",
      slots: "Slot",
      mode: "Mod Latihan",
      location: "Lokasi",
      trainingC: "Sijil Latihan",
      courseType: "Jenis Kursus",
      cpsearch: "Carian penyedia kursus",
      courseProviders: "Penyedia Kursus",
      pillarfocus: "Teras & Bidang Utama",
      archived_courses: "Kursus Arkib",
      skill_areas: "Bidang Kemahiran",
      available_seats: "Tempat Tersedia",
      unlimited_seats: "Tersedia Tanpa Had",
      foc: "PERCUMA",
      level: "Peringkat",
      satelliteEvents: "Acara Satelit",
      searchSatellite: "Carian Acara Satelit",
      enrolments: "Penyertaan",
      findOutMore: "Maklumat Lanjut",
      viewCert: "Lihat Sijil",
      startDatePlaceholder: "Pilih Tarikh Mula",
      selectPillar: "Pilih Teras & Bidang Utama",
      selectSkill: "Pilih Bidang Kemahiran",
      selectSort: "Pilih Pilihan Penyusunan",
      hour: "Jam",
      hours: "Jam",
      totalHour: "Jumlah Jam",
      totalHours: "Jumlah Jam",
      preSchool: "Kanak-kanak Pra-Sekolah",
      teenagers: "Remaja",
      adult: "Dewasa / Pelajar Universiti",
      graduates: "Graduan",
      professionals: "Profesional",
      seniors: "Warga Emas",
      openToAll: "Terbuka",
      oldestFirst: "Paling Lama Dahulu",
      newestFirst: "Terbaru Dahulu",
      oldest: "Paling Lama",
      newest: "Terbaru",
      onlineTraining: "Latihan Dalam Talian",
      visited : "Telah Dilawati"
    }

    public static courseDetailsData = {
      courses: "Kursus",
      search: "Carian kursus",
      courseDetails: "Perincian Kursus",
      startDate: "Tarikh Mula​",
      endDate: "Tarikh Tamat",
      certificate: "Sijil",
      mode: "Mod Latihan",
      state: "Negeri",
      agency: "Agensi",
      contact: "Hubungi",
      pic: "Nama Penyelia",
      number: "Nombor Telefon",
      email: "E-mel",
      related: "Kursus yang Berkaitan",
      slots: "Slot",
      trainers: "Pelatih",
      duration: "Tempoh",
      enroll: "DAFTAR SEKARANG​",
      content: "Kandungan Kursus",
      summary: "Ringkasan Kursus",
      noCourse: "Tiada Kursus Ditemui",
       trainingType:"Training Type",
      skillArea:"Bidang Kemahiran",
      regopensoon:"Pendaftaran akan dibuka kelak",
      trainingprovider:"Penyedia Kursus",
      coursetype:"Jenis Kursus",
      foc: "PERCUMA",
      available_seats: "Tempat Tersedia",
      unlimited_seats: "Tersedia Tanpa Had",
      joinNow: "Sertai Sekarang",
      courseEnded: "Kursus berakhir",
      goNow: "Daftar Sekarang",
      pillar: "Teras",
      docReference: "Rujukan Dokumen",
      blendHybrid: "Pembelajaran Teradun/ Hibrid",
      classRoom: "Bilik darjah",
      coaching: "Kejurulatihan",
      eLearning: "e-Pembelajaran",
      onlineTraining: "Latihan Dalam Talian",
      lifeSkill: "Kemahiran Hidup",
      futureSkill: "Kemahiran Masa Depan",
      creativityInnovation: "Kreativiti & Inovasi",
      financial: "Kewangan",
      sustainableDev: "Pembangunan Mampan",
      pleaseEnroll: "Sila Log Masuk Untuk Daftar Kursus"
    }

    public static faqData = {}

    public static privacyData = {
      title: "NOTIS PERLINDUNGAN DATA PERIBADI",
      privacy: "Dasar Privasi",
      p1: "National Training Week adalah komited untuk melindungi privasi dan keselamatan manamana data peribadi yang mungkin diberikan oleh Individu, Majikan, Penyedia Latihan dan/atau mana-mana Kementerian dan Agensi (“Pengguna”) yang dikumpul daripada National Training Week melalui sebarang soal selidik, borang dan/atau tinjauan dalam talian.",
      p2: "Notis Privasi ini bertujuan untuk menerangkan cara data peribadi anda dikendalikan dan dilindungi dan kewajipan perlindungan data oleh National Training Week bersama-sama dengan hak-hak anda. Apabila anda berkongsi data peribadi anda dengan kami atau apabila kami mengumpul data peribadi anda, kami menggunakannya selaras dengan Dasar Privasi ini. Sila baca maklumat ini dengan teliti. Jika anda mempunyai sebarang pertanyaan dan/atau kebimbangan mengenai data peribadi anda, sila hubungi kami melalui butiran hubungan yang dinyatakan di bawah.",
      title1: "1.	Pengumpulan dan Penggunaan Data Peribadi",
      p3: "Notis Perlindungan Data Peribadi ini dikeluarkan kepada semua Pengguna kami yang dihargai, menurut keperluan Akta Perlindungan Data Peribadi 2010 (“Akta tersebut”) dan peraturan - peraturannya. Sebarang data peribadi yang diberikan oleh Pengguna akan dilindungi menuruti Akta tersebut dan langkah-langkah keselamatan kami yang dilaksanakan untuk memastikan keselamatan Data Peribadi anda.",
      p4: "Kami di National Training Week berhasrat untuk mengendali data-data peribadi anda yang telah didedahkan dan/atau diberikan kepada kami dengan serius. Kami berusaha untuk melindungi data peribadi yang diberikan kepada kami dengan penuh integriti.",
      p5: "Sebagai Pengguna kami yang dihargai, kami akan meminta anda untuk membekalkan data dan maklumat tentang diri anda (“Data Peribadi”) apabila anda berurusan dalam laman web National Training Week (“laman web”) untuk membolehkan kami memahami, memenuhi dan menentukur hasil yang paling sesuai dengan lebih baik, butiran dan/atau maklumat untuk anda dan/atau untuk menyampaikan pemberitahuan, notis, perkhidmatan dan/atau produk yang bersesuaian dengan anda. Data Peribadi anda membolehkan kami mencapai tujuan di sini berkaitan dengan laman web kami.",
      title3: "2.	Sifat Data Peribadi",
      p6: "Data Peribadi tersebut mungkin tertakluk kepada perlindungan data, privasi dan undangundang lain yang serupa. Data Peribadi tersebut membawa maksud sebarang maklumat atau cebisan maklumat yang boleh mengenal pasti anda sama ada secara langsung atau tidak langsung dan/atau maklumat yang menjadikan anda boleh dikenal pasti. Antara lain, Data Peribadi mungkin termasuk maklumat mengenai nama, umur, nombor kad pengenalan, nombor pasport, alamat, jantina, tarikh lahir, status perkahwinan, pekerjaan, maklumat hubungan, alamat e-mel, bangsa, asal etnik dan kewarganegaraan.",
      title4: "3.	Kesan daripada kegagalan membekalkan Data Peribadi",
      p7: "Kegagalan untuk membekalkan Data Peribadi tersebut akan menyebabkan kami tidak dapat:-",
      descA: "memberikan anda notis, perkhidmatan dan/atau program yang diminta;",
      descB: "memaklumkan anda tentang program, kursus dan perkhidmatan terkini yang ditawarkan oleh kementerian dan agensi kerajaan yang berkenaan;",
      descC: "mengesyorkan kursus dan/atau program yang tersedia paling bersesuaian dengan kemahiran profesional, pengalaman dan kelayakan anda.",
      title5: "4.	Tujuan Mengumpul Data Peribadi",
      p8: "Data Peribadi dikumpul, digunakan dan/atau sebaliknya diproses oleh kami untuk membolehkan Pengguna untuk menjadi sebahagian daripada National Training Week, antara lain, tujuan berikut:",
      descAtitle5: "menyelenggara dan mengemas kini penyimpanan rekod dalaman; dan",
      descBtitle5: "memenuhi sebarang keperluan undang-undang atau peraturan dan membuat pendedahan di bawah keperluan mana-mana undang-undang, peraturan, terma dan syarat, arahan, perintah mahkamah, undang-undang kecil, garis panduan, pekeliling, kod yang terpakai untuk National Training Week.",
      title6: "5. Pendedahan Data Peribadi",
      p9: "Data Peribadi yang diberikan kepada kami secara amnya akan dirahsiakan tetapi anda dengan ini membenarkan dan memberi kuasa kepada kami untuk memberikan atau mendedahkan Data Peribadi anda kepada kategori-kategori yang berikut:-",
      descAtitle6: "mana-mana orang yang kami dikehendaki atau diperlukan berbuat demikian di bawah undang-undang;",
      descBtitle6: "pihak berkuasa berkanun, agensi kerajaan dan pengawai kawal selia industri;",
      descCtitle6: "agensi rakan kongsi kami di bawah bidang kuasa agensi kerajaan yang berkaitan;",
      descDtitle6: "perunding, akauntan, juruaudit, peguam atau penasihat kewangan atau profesional kami yang lain;",
      descEtitle6: "pembekal perkhidmatan kami untuk tujuan mewujudkan dan mengekalkan pangkalan data bersama di mana kami mempunyai kepentingan bersama yang sah; dan",
      descFtitle6: "mana-mana kategori lain yang kami anggap perlu.",
      title7: "6. Perlindungan",
      p10: "Kami akan menyimpan dan memproses data anda dengan cara yang selamat. Kami berusaha, di mana praktikal dilaksanakan, untuk melaksanakan perlindungan dan prosedur pentadbiran dan keselamatan yang sesuai mengikut undang-undang dan peraturan yang terpakai untuk menghalang pemprosesan Data Peribadi yang tidak dibenarkan atau menyalahi undang-undang dan kehilangan atau kemusnahan secara tidak sengaja, atau kerosakan terhadap Data Peribadi tersebut.",
      title8: "7. Hak Akses dan Pembetulan",
      p11: "Secara amnya, anda tidak perlu menyerahkan sebarang maklumat peribadi kepada National Training Week, tetapi untuk tujuan anda telah berinteraksi dengan kami dalam laman web, Kami memerlukan anda untuk memberikan maklumat peribadi tertentu supaya kami dapat menapis butiran yang relevan yang paling sesuai untuk anda.",
      p12: "Dalam apa jua keadaan, anda mempunyai hak untuk meminta akses kepada dan pembetulan maklumat anda yang dipegang oleh kami dan dalam hal ini, anda boleh:",
      descAtitle8: "semak sama ada kami memegang atau menggunakan Data Peribadi anda dan meminta akses kepada data tersebut;",
      descBtitle8: "meminta kami membetulkan mana-mana Data Peribadi anda yang tidak tepat, tidak lengkap atau yang lama;",
      descCtitle8: "meminta agar Data Peribadi anda disimpan oleh kami hanya selagi perlu untuk memenuhi tujuan ia dikumpul;",
      descDtitle8: "meminta kami menyatakan atau menerangkan dasar dan prosedur kami berhubung dengan data dan jenis Data Peribadi yang dikendalikan oleh kami;",
      descEtitle8: "menyampaikan kepada kami bantahan anda terhadap penggunaan Data Peribadi anda untuk tujuan pemasaran yang mana kami tidak akan menggunakan Data Peribadi anda untuk tujuan ini; dan",
      descFtitle8: "menarik balik, sepenuhnya atau sebahagian, persetujuan anda yang diberikan sebelum ini, dalam setiap kes tertakluk kepada sebarang sekatan undang-undang yang terpakai, syarat kontrak dan tempoh masa yang munasabah.",
      title9: "8. Pautan ke Laman Lain",
      p13: "Sila ambil perhatian bahawa laman web National Training Week biasanya akan mengandungi pautan ke laman lain yang tidak dikawal oleh Dasar Privasi ini. Kami menggalakkan Pengguna menyemak notis privasi setiap laman web yang dilawati sebelum mendedahkan sebarang maklumat peribadi.",
      p14: "National Training Week tidak akan bertanggungjawab ke atas laman pihak ketiga tersebut. Sebarang maklumat peribadi yang disediakan oleh anda di laman tersebut akan tertakluk kepada dasar privasi pihak ketiga yang berkaitan (jika ada).",
      title10: "9. Persetujuan",
      p15: "Penggunaan laman web kami oleh anda menunjukkan persetujuan anda untuk menggunakan dan mengumpul Data Peribadi anda menurut Notis Perlindungan Data Peribadi ini melainkan dan sehingga anda memaklumkan kami sebaliknya di sini.",
      p16: "Kami berhak untuk menyemak dan mengemas kini dasar Privasi ini dari semasa ke semasa untuk mencerminkan perubahan dalam undang-undang, perubahan dalam amalan perniagaan, prosedur dan struktur kami tanpa notis terlebih dahulu. Kami menasihatkan supaya anda sentiasa menyemak laman web kami untuk mendapatkan Dasar Privasi yang terkini. Versi Dasar Privasi yang terkini akan disediakan di nationaltrainingweek.gov.my.",
      title11: "10. Hubungi Kami",
      p17: "National Training Week adalah komited untuk melindungi privasi dalam talian maklumat peribadi anda. Jika anda mempunyai sebarang soalan atau kebimbangan mengenai Notis Privasi ini atau ingin mendapatkan sebarang maklumat lanjut tentang cara kami melindungi data peribadi anda, sila e-mel kepada kami di taskforce@nationaltrainingweek.gov.my.",
    }

    /**
     * Home page content (new)
     */
    public static homePageDataOverview = {
      
      // title: "TENTANG NATIONAL TRAINING WEEK (NTW)",
      title: "PEMBELAJARAN TANPA SEMPADAN",
      sub_title: "Menginspirasi Keunggulan Rakyat Malaysia menerusi Pembelajaran Sepanjang Hayat",
      // desc_1: "NTW 2024 komited untuk memperkasakan rakyat Malaysia melalui pelbagai inisiatif latihan yang menyeluruh, membolehkan mereka memainkan peranan aktif dalam memajukan pertumbuhan dan kesejahteraan negara, melangkaui peranan sebagai peserta semata-mata.",
      // desc_2: "Ini akan menekankan matlamat acara tersebut untuk melengkapi individu dengan kemahiran yang diperlukan untuk cemerlang dalam pasaran kerja kontemporari, membina budaya pembelajaran sepanjang hayat, dan mendorong kerjasama di antara industri, akademik, dan individu.",
      // desc_3: "",
      // desc_4: "",

      // desc_1: "Dalam dunia yang sentiasa berubah, Minggu Latihan Kebangsaan (NTW) berdiri sebagai harapan, menawarkan akses percuma kepada peluang pembelajaran dan pembangunan berkualiti kepada orang ramai dari pelbagai lapisan masyarakat.",
      // desc_2: "Inisiatif ini bukan sekadar karnival latihan — ia adalah gerakan nasional untuk mempersiapkan kerjaya masa depan, merapatkan jurang kemahiran, dan memupuk budaya pembelajaran sepanjang hayat serta peningkatan kemahiran.",
      // desc_3: "Dengan kerjasama Kementerian Sumber Manusia (KESUMA), HRD Corp bertindak sebagai jambatan - menghubungkan tenaga kerja dengan pemimpin industri, pendidik, dan sumber pembelajaran. NTW bertepatan dengan Tahun Kemahiran ASEAN (AYOS) 2025, menjadikannya salah satu inisiatif utama.",
      // desc_4: "Perkembangan menarik ini bermakna NTW akan meluaskan jangkauannya ke peringkat serantau, mewujudkan kerjasama yang tiada tandingan untuk pertumbuhan kemahiran dan pengetahuan di seluruh ASEAN. Bertemakan, Pembelajaran Tanpa Sempadan, sejajar dengan semangat AYOS 2025, yang menggalakkan kerjasama serantau, keterangkuman, dan inovasi.",
      // desc_5: "Dengan ribuan program latihan, daripada kemahiran digital dan teknologi hijau hingga kepimpinan dan pembuatan maju, NTW adalah pusat sehenti untuk peningkatan kemahiran dan penambahbaikan kemahiran. Sama ada anda graduan baru, profesional pertengahan kerjaya, atau majikan yang ingin meningkatkan pasukan, NTW membuka pintu kepada peluang yang bermakna.",
      // desc_6: "Apa yang membezakan NTW adalah ketercapaian programnya. Semua program ditawarkan secara percuma, memastikan tiada siapa yang ketinggalan dalam perjalanan menuju ekonomi berpendapatan tinggi yang didorong oleh pengetahuan. Dari bandar-bandar besar hingga ke kampung-kampung terpencil, model hibrid NTW — yang menggabungkan sesi secara bersemuka dan dalam talian — mencapai ribuan orang, mengubah kehidupan dan mata pencarian.",
      // desc_7: "NTW bukan sekadar respons kepada krisis kemahiran — ia adalah penyelesaian. Dengan memperkasakan rakyat dengan alat dan peluang pembelajaran yang mudah diakses untuk berjaya dalam dunia yang sentiasa berubah, NTW membentuk tenaga kerja yang lebih cerah, lebih berdaya saing dan bersedia untuk masa depan untuk semua."

      subtitle_1: "Ringkasan​",
      subtitle_2: "Pelajari, Alami, Kuasai",
      desc_1: "Minggu Latihan Kebangsaan (NTW) menyediakan akses percuma kepada peluang pembelajaran dan pembangunan berkualiti untuk semua rakyat Malaysia, tanpa mengira latar belakang.",
      desc_2: "Berfokuskan pembelajaran sepanjang hayat dan peningkatan kemahiran, NTW memperkasa individu untuk terus maju dalam ekonomi yang sentiasa berkembang. Melalui kerjasama dengan Kementerian Sumber Manusia (KESUMA), HRD Corp berperanan sebagai penghubung antara tenaga kerja dengan peneraju industri, pendidik serta pelbagai sumber pembelajaran yang bernilai.​",
      desc_3: "Selaras dengan tonggak Kesejahteraan dalam gagasan Malaysia MADANI, tema ini mencerminkan komitmen HRD Corp menerusi NTW untuk memperkasa individu dengan kemahiran dan pengetahuan yang diperlukan bagi meningkatkan jaminan ekonomi serta kualiti hidup.",
      desc_4: "Dengan memperluas akses kepada peluang pembelajaran, NTW menyokong aspirasi bersama untuk membangunkan tenaga kerja Malaysia yang lebih berkemahiran, berdaya saing dan bersedia menghadapi cabaran masa hadapan.​"
    
    };
    public static homePageDataObjectives = {
      // title: "OBJEKTIF",
      title: "Objektif Kami",
      desc_1: "Membudayakan pembelajaran sepanjang hayat dalam kalangan rakyat Malaysia",
      desc_2: "Meningkatkan kerjasama strategik antara Kerajaan untuk pembangunan dan latihan",
      desc_3: "Melengkapkan rakyat Malaysia dengan ilmu dan kemahiran kerja masa hadapan",
    };
    public static homePageDataPillars = {
      // title: "TUMPUAN & BIDANG UTAMA",
      title: "Teras & Bidang Utama",
      sub_title: "",
      pillar_1_title: "Kemahiran Hidup",
      pillar_1_desc: "Pembangunan Peribadi dan Pencapaian Diri",
      pillar_2_title: "Kemahiran Masa Depan",
      pillar_2_desc: "STEM, TVET, Digitalisasi, Kecerdasan Buatan (AI) & Kejuruteraan Mesin",
      pillar_3_title: "Kreativiti & Inovasi",
      pillar_3_desc: "Muzik, Seni, Budaya & Pendidikan Kreatif",
      pillar_4_title: "Kewangan",
      pillar_4_desc: "Bank, Insurans, Pelaburan & Teknologi Kewangan",
      pillar_5_title: "Pembangunan Mampan",
      pillar_5_desc: "Alam Sekitar, Pembangunan, Kesamarataan & Kemakmuran",
    };
    public static homePageDataTargetGroups = {
      // title: "KUMPULAN SASARAN",
      title: "Kumpulan Sasaran",
      sub_title: "NTW akan mengetengahkan pelbagai aktiviti untuk rakyat Malaysia yang terdiri daripada:",
      individuals: "Individu",
      pre_school_children: "Kanak-kanak Pra-Sekolah",
      teenagers: "Remaja",
      young_adults: "Pelajar Universiti dan Golongan Belia",
      graduates: "Graduan",
      professionals: "Golongan Profesional",
      senior_citizens: "Warga Emas",
      industry_players: "Pemain Industri",
      employers: "Majikan",
      industry_associations: "Persatuan Industri",
      business_chambers: "Dewan Perniagaan",
      training_n_delivery_partners: "Rakan Latihan & Penyampaian",
      online_providers: "Pembekal Platform Dalam Talian",
      training_providers: "Jurulatih dan Penyedia Latihan",
      academic_institution: "Institusi Akademik",
      skill_based_institutions: "Institusi Berasaskan Kemahiran",
      learning_centres: "Pusat Pembelajaran Fizikal",
      tuition_centres: "Tadika dan Pusat Tuisyen",
    };
    public static homePageDataBenefits = {
      // title: "MANFAAT",
      title: "Manfaat Kami",
      // individual: "INDIVIDU",
      individual: "Individu",
      individual_desc_1: "Memahami kepentingan latihan dalam pembangunan diri.",
      individual_desc_2: "Meningkatkan motivasi, produktiviti dan keyakinan diri.",
      individual_desc_3: "Meningkatkan peluang pekerjaan dan kemajuan kerjaya.",
      // industry: "INDUSTRI",
      industry: "Industri",
      industry_desc_1: "Membolehkan penyedia latihan menawarkan kursus yang relevan berdasarkan agenda ekonomi negara.",
      industry_desc_2: "Meningkatkan kesedaran majikan tentang kursus kemahiran yang sesuai dengan pekerja dan bakal pekerja.",
      industry_desc_3: "Menangani jurang kemahiran dan merekrut pekerja yang tepat.",
      // nation: "NEGARA",
      nation: "Negara",
      nation_desc_1: "Membantu Kerajaan mencapai sasaran 35% pekerja mahir menjelang 2030.",
      nation_desc_2: "Menyemai kerjasama erat antara Kerajaan Persekutuan dengan Kerajaan Negeri ke arah memperkasakan inisiatif pembangunan modal insan.",
      nation_desc_3: "Menarik lebih banyak pelaburan asing dengan gabungan tenaga kerja dinamik dan serba mahir.",
    };
    
    public static homePageDataSocial = {
      title: "Dinding Sosial",
    };

    public static footerDataNew = {
      text_1: "Penafian: HRD Corp tidak bertanggungjawab terhadap sebarang kehilangan atau kerosakan yang dialami kerana menggunakan maklumat dalam portal ini.",
      text_2: "Hak Cipta © 2026 HRD Corp Hak Cipta Terpelihara", 
      text_3: "Dasar Keselamatan dan Privasi",
    };
    public static courseSection = {
      viewall: "Lihat Semua Kursus",
    };
    public static onlineCourses = {
      // title: "E-PEMBELAJARAN",
      title: "E-Pembelajaran",
      // subtitle: "Lebih daripada 55,000 kursus percuma ditawarkan di dalam portal NTW",
      subtitle: "Belajar bila-bila masa, di mana sahaja! Lihat kursus popular kami.",
      subtitle2: "Mulakan langkah pertama. Terokai, tingkatkan dan perkasakan kemahiran anda.",
      courses: "Kursus"

    };

    public static trendingOnlineCourses = {
      title: "Kursus E-Pembelajaran Trending",
    };

    public static achievementSection = {
      title: "Peringkat Pencapaian",
      subtitle: "Tamatkan sebanyak mungkin latihan untuk dianugerahkan lencana pengiktirafan sebagai tanda kemajuan dan pencapaian anda.",
      total_training_hour : 'Jumlah jam latihan ' ,
      current_achivement : 'Status pencapaian semasa : Dalam Proses',
      highest_achievement : 'Status pencapaian tertinggi: Selesai',
      hour : 'jam',
      pioneer: "Pelopor",
      explorer: "Penjelajah",
      challenger: "Pencabar",
      trailblazer: "Perintis",
      legend: "Legenda",
      descPioneer: 'Ambil langkah pertama dan mulakan perjalanan.',
      descExplorer: 'Timba pengalaman dan luaskan pandangan.',
      descChallenger: 'Hadapi rintangan dan cekalkan matlamat.',
      descTrailblazer: 'Capai tahap penguasaan dan terus ke hadapan.',
      descLegend: 'Menuju puncak kejayaan dan jadi inspirasi kepada yang lain.',

      locked: "Terkunci",
      unlocked: "Berjaya",
    };

    public static satelliteEvents = {
      title: "Acara Satelit",
      subtitle: "Alami kuasa pembelajaran di acara satelit NTW—di mana komuniti tempatan bertemu peluang global.",
      jan: "Januari",
      feb: "Februari",
      mar: "Mac",
      apr: "April",
      may: "Mei",
      jun: "Jun",
      jul: "Julai",
      aug: "Ogos",
      sept: "September",
      oct: "Oktober",
      nov: "November",
      dec: "Disember",
      search: "Carian",
      viewall: "Lihat Semua"
    };

    
  public static resourceData = {
    resources: "Sumber",
    individualGuideline: "Garis Panduan Individu",
    tpGuideline: "Garis Panduan Penyedia Kursus",
    postTrainingCert: "Garis Panduan Laporan Pasca Latihan & e-sijil",
    brandGuideline: "Garis Panduan Jenama",
    logoFullColor: "Logo NTW Warna Penuh",
    logoBlack: "Logo NTW Hitam",
    logoGreenWhite: "Logo NTW Hijau Putih",
    logoWhite: "Logo NTW Putih",

  };
}